import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';

import {
  loadProductsPage,
  loadRecommendedProductsForPage,
  openMobileRefineBy,
} from '../actions/catalogue';
import { loadCatalogueSubNavigation } from 'apps/navigation/actions/navigation';

import ProductsPageRoute from 'apps/productsPages/utils/ProductsPageRoute';

import AfterLoginFreshener from 'apps/user/containers/AfterLoginFreshener';
import OnOfferPageComponent from '../components/OnOfferPage';
import { isCustomerAcquisition2018 } from 'lib/features';

class OnOfferPage extends PureComponent {
  static propTypes = {
    refreshPage: PropTypes.func.isRequired,
  };

  render() {
    const { refreshPage, ...otherProps } = this.props;

    return (
      <Fragment>
        <AfterLoginFreshener refreshPage={refreshPage} />
        <OnOfferPageComponent {...otherProps} />
      </Fragment>
    );
  }
}

const fetchHook = ({ dispatch, route }) => (
  dispatch(loadProductsPage(route))
);

const deferHook = ({ dispatch, route }) => {
  // these do not need to be wrapped with Promise.all(), as all can be added independently
  dispatch(loadCatalogueSubNavigation(null, { route }));
  dispatch(loadRecommendedProductsForPage(route));
};

export default provideHooks({
  fetch: ({ location, params, dispatch }) => {
    const route = new ProductsPageRoute(location, params);
    return fetchHook({ dispatch, route });
  },
  defer: ({ location, params, dispatch }) => {
    const route = new ProductsPageRoute(location, params);
    return deferHook({ dispatch, route });
  },
})(connect(
  (state, ownProps) => {
    const productsPageRoute = new ProductsPageRoute(ownProps.location, ownProps.params);
    const routeString = productsPageRoute.toString();
    const { basePath } = productsPageRoute;

    const isStickySidebarEnabled = isCustomerAcquisition2018(state);
    const isOOSCheckLinkVisible = state.user.betaFeatures.includes('HIDE_OOS_ITEMS') && state.deliverySlot;

    return {
      basePath,
      betaFeatures: state.user.betaFeatures,
      fopViewPreference: state.user.fopViewPreference,
      productsPage: state.catalogue.productsPagesByRoute[routeString],
      isStickySidebarEnabled,
      routeString,
      isOOSCheckLinkVisible,
    };
  },
  (dispatch, ownProps) => ({
    ...bindActionCreators({ openMobileRefineBy }, dispatch),
    refreshPage() {
      const route = new ProductsPageRoute(ownProps.location, ownProps.params);
      fetchHook({ dispatch, route }).then(() => deferHook({ dispatch, route }));
    },
  })
)(OnOfferPage));
